export enum ContainerType {
	General = 0,
	MyKantar = 1,
	Creative = 2
}

export interface ContainerPermissions {
	managers?: string[];
	writers?: string[];
	readers?: string[];
}

export interface CreateContainerDto {
	name: string;
	description?: string;
	client_id: number;
	client_name: string;
	container_type: string;
	service_principals: string[];
	permissions?: ContainerPermissions;
}
